import C from '../constants';
import P from '../pages';
import appReducer from './reducers';
import thunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import { setPage, setNextPage, setPreviousPage } from '../actions';

const pageNavigator = store => next => action => {

  let result;

  // console.groupCollapsed(`dispatching action => ${action.type}`);
  result = next(action);
  let {
    page,
    pages,
    terms,
    registered,
    content,
    environment,
    nextPage,
    previousPage,
    withdrawn,
    referralProgram,
    language_options,
    ethnicity_options,
    holding,
    affiliate,
    proceedFromHolding,
    territory,
    address
  } = store.getState();
  let next_page, previous_page;

  if (page && pages) {
    let index = pages.indexOf(page);
    let first_page = pages[0];
    const registerOrAddress = (
      page == P.REGISTER_PAGE ||
      page == P.ADDRESS_PAGE ||
      page == P.FIREBASE_REGISTER_PAGE ||
      page == P.FIREBASE_DETAILS_PAGE
    )

    if (index > -1) {
      next_page = pages[index + 1];
      previous_page = pages[index - 1];
    }

    if (page == P.ADDRESS_PAGE && !registered && address && territory.host_address_check) {
      store.dispatch(setPage(P.REGISTER_PAGE))
    }
    else if (registerOrAddress && !terms && registered && !holding) {
      store.dispatch(
        setPage(P.PHONE_VERIFICATION_PAGE)
      );
    }
    else if (registerOrAddress && !terms && registered && holding) {
      store.dispatch(
        setPage(P.HOLDING_PAGE)
      );
    }
    else if (page == P.HOLDING_PAGE && holding && registered && proceedFromHolding) {
      store.dispatch(
        setPage(P.PHONE_VERIFICATION_PAGE)
      );
    }
    else if (page == P.INFO_PAGE && terms && registered) {
      store.dispatch(
        setPage(first_page)
      );
    }
    else if (page == P.INFO_PAGE && withdrawn && registered) {
      store.dispatch(
        setPage(P.WITHDRAW_PAGE)
      );
    }
    else if (page == P.WITHDRAW_PAGE && !withdrawn && registered) {
      store.dispatch(
        setPage(P.PHONE_VERIFICATION_PAGE)
      );
    }
    else if (page == P.REFERRAL_PAGE && !referralProgram) {
      store.dispatch(
        setPage(P.CONTACT_PAGE)
      );
    }
    else if (page == P.PHONE_VERIFICATION_PAGE && nextPage && registered) {
      store.dispatch(setPage(P.INFO_PAGE))
    }
    else if (nextPage) {
      store.dispatch(
        setNextPage(false)
      );
      store.dispatch(
        setPage(next_page)
      );
    }
    else if (previousPage) {
      store.dispatch(
        setPreviousPage(false)
      );
      store.dispatch(
        setPage(previous_page)
      );
    }
  }
  window.gs = store.getState()
  return result;
};

export default createStore(
  appReducer,
  applyMiddleware(thunk, pageNavigator)
)
